// NOTE: Please format dates like YYYY-MM-DD
export const stuysquadVideos = [
    {
        name: "Flow Ame | StuySquad 2023 - 2024",
        date: "2024-01-19",
        videoLink: "https://www.youtube.com/embed/HnlHGhm8T18",
    },
    {
        name: "Flow Yuki | StuySquad 2023 - 2024",
        date: "2024-01-19",
        videoLink: "https://www.youtube.com/embed/iME4BInKNvM",
    },
    {
        name: "Flow | Stuy Squad 2014-2015",
        date: "2015-01-24",
        videoLink: "https://www.youtube.com/embed/cdZCq2OsH4Q",
    },
    {
        name: "Flow | Stuy Squad 2015-2016",
        date: "2016-01-06",
        videoLink: "https://www.youtube.com/embed/BpDb9-_3pS8",
    },
    {
        name: "Flow | StuySquad 2017-2018",
        date: "2018-01-15",
        videoLink: "https://www.youtube.com/embed/AM7C4NcFhIM",
    },
    {
        name: "Flow B | Stuy Squad 2018-2019",
        date: "2018-12-15",
        videoLink: "https://www.youtube.com/embed/oRkKHhwfvIo",
    },
    {
        name: "Flow Omega Ω | StuySquad 2019-2020",
        date: "2020-02-05",
        videoLink: "https://www.youtube.com/embed/XQTkgjuIpOE",
    },
    {
        name: "Flow Kappa κ | StuySquad 2019-2020",
        date: "2020-02-06",
        videoLink: "https://www.youtube.com/embed/RfybWeXABdY",
    },
    {
        name: "Flow A | FRONT ROW | Stuy Squad 2018-2019",
        date: "2018-12-15",
        videoLink: "https://www.youtube.com/embed/bN_SI8HDiHA?start=326",
    },
    {
        name: "Flow Dusk | Stuysquad 2020-2021",
        date: "2021-02-02",
        videoLink: "https://www.youtube.com/embed/yYDeWRLmZh0",
    },
    {
        name: "Flow Dawn | Stuysquad 2020-2021",
        date: "2021-02-02",
        videoLink: "https://www.youtube.com/embed/6PcSCCnVYHU",
    },  
    {
        name: "Flow Aki | StuySquad 2021 - 2022",
        date: "2022-02-11",
        videoLink: "https://www.youtube.com/embed/JxPvCdrCfd0"
    },
    {
        name: "Flow Haru | StuySquad 2021 - 2022",
        date: "2022-02-11",
        videoLink: "https://www.youtube.com/embed/uOPaCLHcroQ"
    }
    
]
